export const GET_ANEXO = 'deca.GET_ANEXO';
export const SET_ANEXO = 'deca.SET_ANEXO';
export const SET_ANEXO_CUSTOMIZADO = 'deca.SET_ANEXO_CUSTOMIZADO';
